import { apiClient } from '../api';

const CHUNK = 100;

export const triageApi = {
  async getVerdicts(keys) {
    const out = {};
    for (let i = 0; i < keys.length; i += CHUNK) {
      const chunk = keys.slice(i, i + CHUNK);
      const { data } = await apiClient.get('/api/triage/verdicts', { params: { keys: chunk.join(',') } });
      Object.assign(out, data.verdicts || {});
    }
    return out;
  },

  async sendFeedback(id, payload) {
    const { data } = await apiClient.put(`/api/triage/verdicts/${encodeURIComponent(id)}/feedback`, payload);
    return data.verdict;
  },

  async getMetrics() {
    const { data } = await apiClient.get('/api/triage/metrics');
    return data.metrics;
  },

  async download(format) {
    const { data } = await apiClient.get('/api/triage/export', { params: { format }, responseType: 'blob' });
    return data;
  },
};
